export default function initProductRequest() {
  const isPresent = document.querySelector(".product-card");
  if (!isPresent) {
    return;
  }

  const productCards = document.querySelectorAll(".product-card");
  const productSummary = document.querySelector(".product-summary");
  const productsInfoTextarea = document.querySelector(
    ".js-products-info textarea"
  );
  const productsFormWrap = document.querySelector(".products-form-wrap");

  const stringRemove = productSummary.dataset.stringRemove;
  const stringAmount = productSummary.dataset.stringAmount;

  productCards.forEach((card) => {
    card.addEventListener("click", function () {
      const productId = this.dataset.id;
      const productTitle = this.dataset.title;
      const productAmount = this.dataset.amount;

      this.classList.toggle("active");

      if (this.classList.contains("active")) {
        addToSummary(productId, productTitle, productAmount);
      } else {
        removeFromSummary(productId);
      }

      updateProductsInfo();
      updateSummaryNumbers();
      updateFormWrapClass();
    });
  });

  function addToSummary(id, title, amount) {
    if (!productSummary.querySelector(`.summary-item[data-id="${id}"]`)) {
      const summaryItem = document.createElement("div");
      summaryItem.classList.add("summary-item");
      summaryItem.dataset.id = id;
      summaryItem.innerHTML = `
              <span class="summary-item-title">${title}</span>
              <span class="amount-meta-title">${stringAmount}:</span>
              <div class="amount-meta">
                <div class="amount-controls">
                    <button class="minus-btn"></button>
                    <input type="number" value="${amount}" class="amount-input" min="1">
                    <button class="plus-btn"></button>
                </div>
                <button class="remove-btn">${stringRemove}</button>
              </div>
          `;

      summaryItem
        .querySelector(".remove-btn")
        .addEventListener("click", function () {
          removeFromSummary(id);
          document
            .querySelector(`.product-card[data-id="${id}"]`)
            .classList.remove("active");
          updateProductsInfo();
          updateSummaryNumbers();
          updateFormWrapClass();
        });

      summaryItem
        .querySelector(".minus-btn")
        .addEventListener("click", function () {
          const input = this.nextElementSibling;
          if (input.value > 1) {
            input.value--;
            document.querySelector(
              `.product-card[data-id="${id}"]`
            ).dataset.amount = input.value;
            updateProductsInfo();
          }
        });

      summaryItem
        .querySelector(".plus-btn")
        .addEventListener("click", function () {
          const input = this.previousElementSibling;
          input.value++;
          document.querySelector(
            `.product-card[data-id="${id}"]`
          ).dataset.amount = input.value;
          updateProductsInfo();
        });

      summaryItem
        .querySelector(".amount-input")
        .addEventListener("change", function () {
          if (this.value < 1) {
            this.value = 1;
          }
          document.querySelector(
            `.product-card[data-id="${id}"]`
          ).dataset.amount = this.value;
          updateProductsInfo();
        });

      productSummary.appendChild(summaryItem);
      productSummary.classList.remove("hidden");
    }
  }

  function removeFromSummary(id) {
    const itemToRemove = productSummary.querySelector(
      `.summary-item[data-id="${id}"]`
    );
    if (itemToRemove) {
      productSummary.removeChild(itemToRemove);
      if (productSummary.children.length === 0) {
        productSummary.classList.add("hidden");
      }
    }
  }

  function updateProductsInfo() {
    const summaryItems = productSummary.querySelectorAll(".summary-item");
    let productsInfo = "";

    summaryItems.forEach((item, index) => {
      const id = item.dataset.id;
      const title = item.querySelector(".summary-item-title").textContent;
      const amount = item.querySelector(".amount-input").value;
      productsInfo += `${
        index + 1
      }. ${title} (ID: ${id}) / kogus: ${amount}tk\n`;
    });

    productsInfoTextarea.value = productsInfo.trim();
  }

  function updateSummaryNumbers() {
    const summaryItems = productSummary.querySelectorAll(".summary-item");
    summaryItems.forEach((item, index) => {
      const numberSpan = item.querySelector(".summary-item-number");
      if (!numberSpan) {
        const numberElement = document.createElement("span");
        numberElement.classList.add("summary-item-number");
        item.insertBefore(numberElement, item.firstChild);
      }
      item.querySelector(".summary-item-number").textContent = `${index + 1}. `;
    });
    updateProductsInfo();
  }

  function updateFormWrapClass() {
    if (productSummary.children.length === 0) {
      productsFormWrap.classList.add("inactive");
    } else {
      productsFormWrap.classList.remove("inactive");
    }
  }

  // Initial check
  updateFormWrapClass();
}
